export default __webpack_public_path__ + "static/media/section2_Image.14d62e95.png";